<app-wrapper>
  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Заказ №{{ model?.number ?? '_' }}
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">

        </div>
      </div>
    </div>

    <div class="row g-5 gy-7">
      <div class="col-12 col-xl-8 col-xxl-9">
        <div class="table-responsive scrollbar">
          <table class="table fs--1 mb-0 border-top border-200">
            <thead>
              <tr>
                <th class="text-center" style="width: 5%;">№ п/п</th>
                <th style="width: 40%;">Продукт</th>
                <th class="text-center" style="width: 15%;">Количество</th>
                <th class="text-center" style="width: 20%;">Цена</th>
                <th style="width: 30%;">Дополнительно</th>
              </tr>
            </thead>
            <tbody class="list">
              @for (item of model?.items; track item; let i = $index) {
                <tr>
                  <td class="text-center">{{ i + 1}}</td>
                  <td>
                    <a target="_blank" [routerLink]="[ '/products/edit/' + item.productInfo?.id]">
                      {{ item.name }}
                    </a>
                  </td>
                  <td class="text-center">{{ item.count }}</td>
                  <td class="text-center">{{ getItemPrice(item) | number: '.2-2'}}</td>
                  <td>
                    @if (item.modificators?.length ?? 0 > 0) {
                      <ul>
                        @for (modificator of item?.modificators; track modificator) {
                          <li>
                            {{ modificator.name }}
                            (+{{modificator.price}})
                          </li>
                        }
                      </ul>
                    }
                  </td>
                </tr>
              }
              <tr>
                <td colspan="4" class="text-end">Итого:</td>
                <td>
                  <b>{{ model?.totalSum | number: '.2-2'}}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      @if (model) {
        <div class="col-12 col-xl-4 col-xxl-3">
          <div class="col-12 mb-4">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title mb-4">Статусы</h3>
                <h6 class="w-100">
                  Статус заказа
                </h6>
                <div class="d-flex mb-4">
                  <select class="form-select" [(ngModel)]="model!.orderStatus" name="orderStatus">
                    @for (item of orderStatuses; track item) {
                      <option [value]="item">
                        {{ item | orderStatus }}
                      </option>
                    }
                  </select>
                  <button class="btn btn-primary ms-1" (click)="setOrderStatus()">Установить</button>
                </div>
                <h6 class="w-100">
                  Статус оплаты
                </h6>
                <div class="d-flex mb-4">
                  <select class="form-select" [(ngModel)]="model!.paymentStatus" name="paymentStatus">
                    @for (item of paymentStatuses; track item) {
                      <option [value]="item">
                        {{ item | paymentStatus }}
                      </option>
                    }
                  </select>
                  <button class="btn btn-primary ms-1" (click)="setPaymentStatus()">Установить</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h3 class="card-title mb-4">
                Информация
              </h3>
              <div class="mb-4">
                <h6><i class="fa-solid fa-calendar"></i> Дата</h6>
                <p class="mb-0 text-800 fs--1">{{ model.utcDate | date: 'dd.MM.yyyy HH:mm:ss' }}</p>
              </div>
              @if (model.toTime) {
                <div class="mb-4">
                  <h6><i class="fa-solid fa-clock"></i> Ко времени</h6>
                  <p class="mb-0 text-800 fs--1">{{ model.toTime | date: 'dd.MM.yyyy HH:mm:ss' }}
                    <p>
                    </div>
                  }
                  <div class="mb-4">
                    <h6><i class="fa-solid fa-user"></i> Контактные данные</h6>
                    <p class="mb-0 text-800 fs--1">{{ model.contactName }} ({{ model.contactPhone }})</p>
                  </div>
                  <div class="mb-4">
                    <h6><i class="fa-solid fa-credit-card"></i> Тип оплаты</h6>
                    <p class="mb-0 text-800 fs--1">{{ model.paymentType | paymentType }}</p>
                  </div>
                  @if (model.deliveryAddress) {
                    <div class="mb-4">
                      <h6><i class="fa-solid fa-location-dot"></i> Адрес доставки</h6>
                      <p class="mb-0 text-800 fs--1">{{ model.deliveryAddress }}
                        <p>
                        </div>
                      }
                      <div class="mb-4">
                        <h6><i class="fa-solid fa-comment"></i> Комментарий</h6>
                        <p class="mb-0 text-800 fs--1">{{ model.comment ?? '---' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>

            @if (isBusy) {
              <div class="overlay">
                <i class="fa-solid fa-spinner fa-spin"></i>
              </div>
            }
          </div>

        </app-wrapper>